export interface ActivityIndicatorProps {
  type: ActivityIndicatorType;
  size: ActivityIndicatorSize;
  className?: string;
  testId?: string;
  /** Lands on the pulse ring only, so a test can tell a pulsing dot from a plain one. */
  pulseTestId?: string;
}

export enum ActivityIndicatorType {
  NEW,
  NEW_PULSE,
  LOADING,
  SUCCESS,
  ERROR,
}

export enum ActivityIndicatorSize {
  SIZE_12,
  SIZE_16,
}
